export default __webpack_public_path__ + "8f7e2b5cfa5fc0a0aefb3e9106685abd.svg";